import { formatLocDateMMDDYYYY } from '@mummssoftware/utils/formatters';
import React from 'react';
import { useIntl } from 'react-intl';
import messages from '../PatientHeader/messages';
import { PrintPreviewTextContainer, PrintPreviewOnlyFooterDiv } from './styled-divs/PrintPreviewStyledDivs';
export const PrintPreviewFooter = () => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(PrintPreviewOnlyFooterDiv, null, /*#__PURE__*/React.createElement(PrintPreviewTextContainer, null, /*#__PURE__*/React.createElement("p", null, `${formatMessage(messages.printedOn)}: `, formatLocDateMMDDYYYY(new Date()))));
};
export default PrintPreviewFooter;